import locale from "@packs/locale/locale"
import stationHelper from "../../../helpers/station_helper"

import spinners from "@components/loader/spinners"
import store from "../../../store/store"
import dam_helper from "../../../helpers/dam_helper"
import('./chart.css')

export default function Chart(opts={}){
    BaseConstructor.call(this)
    let {container} = opts
    let elements = {}
    let context = this
    let _chart
    let current_station
    let current_measurements

    this.generate = () =>{
        $(container).html('')
        elements.container = this.createElement('div', '', '')
        elements.loading = this.createElement('div', 'modal-measurements-loading-container', '')
        elements.loading_content = this.createElement('div', 'modal-measurements-loading-content', '')
        $(elements.loading_content).html(spinners.defaultSpinner(1,'#37384e') + "<div>Carregando dados, aguarde</div>")
        $(elements.loading).append(elements.loading_content)
        $(elements.container).css({
            height: '500px',
            width: '100%',
            position: 'relative'
        })
        $(container).append(elements.container,elements.loading)
    }

    this.generateChart = (station, start_date, end_date,measurements) =>{
        current_station = station

        if(_chart){
            this.destroy()
        }

        if(measurements && measurements.length > 0){
            current_measurements = measurements
            generateChart()
            updateChart()
        }

    }

    this.update = () =>{
        this.generateChart()
        updateChart()
    }

    this.destroy = () =>{
        if(_chart){
            _chart.destroy()
            _chart = undefined
        }
    }

    this.loading = boolean =>{
        $(elements.loading).toggleClass('show',boolean)
    }

    const updateChart = () =>{
        let series = generateSeries(current_measurements)

        let plotlines = generatePlotLines(current_station)
        
        _chart.update({
            series: series
        })
        
        addPlotLines()

        setChartLimits(plotlines,current_measurements)
    }

    const addPlotLines = _ =>{
        let plotlines = generatePlotLines(current_station)

        _chart.yAxis[0].update({
            plotLines: plotlines['level']
        });

        setChartLimits(plotlines)
    }

    const removePlotLines = _ =>{
        _chart.yAxis[0].update({
            plotLines: []
        });
    }

    const setChartLimits = () =>{
        let plotlines = _chart.yAxis[0].plotLinesAndBands
        if(plotlines.length > 0){
            //lista de valores das plotlines
            let plot_values = plotlines.map(x=>x.options.value)

            //valores das plotlines + valores das medições
            let all_values = [...plot_values, ...current_measurements.map(x=>x.value/100)]

            //definindo o minimo e maximo do eixo Y
            _chart.yAxis[0].setExtremes(Math.min(...all_values), Math.max(...all_values))
        } else {
            _chart.yAxis[0].setExtremes()
        }
        
    }



    function generatePlotLines(station){
        let reference_values = station.reference_values
        let plotlines = {}
        if(reference_values){
            let fields = ['extravasation', 'emergency', 'alert', 'attention']
            fields.forEach(field=>{
                if(reference_values.values[field]){
                    plotlines['level'] = plotlines['level'] || []
                    plotlines['level'].push({
                        value: parseFloat(reference_values.values[field])/100,
                        dashStyle: 'shortdash',
                        color: stationHelper.colorByReference(field).full,
                        width: 2,
                        zIndex: 5,
                        label: {
                            text: `<div style="font-size:x-small;border-radius:3px;padding:1px 3px;background-color:${stationHelper.colorByReference(field).full};color:white">${locale.t(field).toUpperCase()}</div>`,
                            useHTML: true
                        }
                    })
                }
                
            })
        }
        return plotlines
    }

    function generateSeries(measurements,series_options = {}){
        measurements = measurements.sort((x,y)=>  new Date(x.date) - new Date(y.date))

        //data type atual
        let data_type = store.informationCardStore.getDataType()

        let series = []

        let data_value = {} //chuva nivel
        let data_read_value = {} //vazao chuva acumulada
        if(measurements.length > 0){

            measurements.forEach(measurement =>{
                data_value[`${measurement.prefix}-${measurement.station_type_id}`] = data_value[`${measurement.prefix}-${measurement.station_type_id}`] || []
                data_value[`${measurement.prefix}-${measurement.station_type_id}`].push({x:moment(measurement.date, "YYYY-MM-DDTHH:mm:ss.SSSZ").subtract(3, 'hours').valueOf(),y:measurement.value})
                if(measurement.read_value_flu > 0){
                    data_read_value[`${measurement.prefix}-${measurement.station_type_id}`] = data_read_value[`${measurement.prefix}-${measurement.station_type_id}`] || []
                    data_read_value[`${measurement.prefix}-${measurement.station_type_id}`].push({x:moment(measurement.date, "YYYY-MM-DDTHH:mm:ss.SSSZ").subtract(3, 'hours').valueOf(), y:parseFloat(measurement.read_value_flu.toFixed(3))})
                }
                
            })

            if(data_type.includes('level') || data_type.includes('flow')){
                series.push(
                    {
                        name: 'NÍVEL',
                        data: data_value[Object.keys(data_value)[0]].map(x=>[x.x,parseFloat((x.y/100).toFixed(3))]),
                        yAxis: 0,
                        type: 'line'
                    }
                );

                if(data_type.includes('flow')){
                    //calculando vazões do posto
                    measurements = stationHelper.calculateFlows(measurements, current_station.id)

                    //criando série
                    data_read_value = []
                    measurements.forEach(measurement=>{
                        data_read_value.push({x:moment(measurement.date, "YYYY-MM-DDTHH:mm:ss.SSSZ").subtract(3, 'hours').valueOf(), y:parseFloat(measurement.read_value.toFixed(3))})
                    })

                    //modificando a série para 'cruzar' com os dados de comportas
                    data_read_value = dam_helper.flowWithFloodgates(data_read_value)

                    series.push(
                        {
                            name: 'VAZÃO',
                            data: data_read_value,
                            yAxis: 1,
                            type: 'line'
                        }
                    );
                }

                series.push(
                    {
                        name: 'VALORES DE REFERÊNCIA',
                        yAxis: 0,
                        id: 'reference_values'
                    }
                );

                
            } else {
                $.each(data_value, (station_id, data) =>{
                    series.push(
                        {
                            name: station_id.split('-')[0],
                            data: data,
                            yAxis: 0,
                            type: 'column'
                        }
                    );
                })

                //média de chuva acumulada por timestamp
                let acum_series = {}
                let acumSeries = []
                $.each(data_value, (key, data)=>{
                    data.forEach(value=>{
                        acum_series[value.x] = acum_series[value.x] || []
                        acum_series[value.x].push(value.y)
                    })
                })

                //sort pois nem sempre o timestamp fica na ordem correta
                const entries = Object.entries(acum_series);
                entries.sort(([a], [b]) => parseInt(a) - parseInt(b));
                const sortedAcumSeries = Object.fromEntries(entries);


                let accum = 0
                $.each(sortedAcumSeries, (timestamp, array)=>{
                    let value = _.mean(array)
                    accum += value
                    acumSeries.push([parseInt(timestamp), accum])
                })

                //adicionando série de média de chuva acumulada
                series.push(
                    {
                        name: 'MÉDIA ACUMULADA',
                        data: acumSeries,
                        yAxis: 1,
                        type: 'line'
                    }
                );
            }
        }
        return series
    }

    const generateChart = () =>{
        let series = generateSeries(current_measurements)

        //data type atual
        let data_type = store.informationCardStore.getDataType()

        _chart = Highcharts.chart(elements.container, {
            chart:{
                type: 'line',
                zoomType:"x",
                
            },
            title:{
                text: ''
            },
            yAxis: [
                {
                    title: {
                        text: ''
                    },
                    labels:{
                        format: `{value} ${data_type.includes('level') || data_type.includes('flow') ? 'm' : 'mm'}`
                    },
                    plotLines:[],
                },
                {
                    title: {
                        text: data_type.includes('rain') ? 'Chuva acumulada' : 'Vazão'
                    },
                    opposite:true,
                    labels:{
                        format: `{value} ${data_type.includes('rain') ? 'mm' : 'm³/s'}`,
                    }
                }
            ],
            xAxis: {
                title:{

                },
                events:{
                    afterSetExtremes: function(e){
                        setChartLimits()
                    }  
                },
                
                type: 'datetime'
            },
            tooltip:{
                shared:true,
                formatter: function (e){
                    let html = ""
                    html += "<span style='font-size: x-small'>" + moment(this.x).format('DD/MM/YYYY HH:mm') + "</span><br>"
                    $.each(this.points, function(index, point){
                        let text = ""
                        let name = point.series.userOptions.name
                        let gates_count = point.point.options.a || undefined
                        let value = point.point.options.y
                        text += name+': <b><span style="color:'+ point.color +'">' + (data_type.includes('rain') ? value.toFixed(2) : value.toFixed(3))  +'</span></b><br/>'  
                        if(gates_count>=0){
                            text += '<b>Comportas abertas: ' + gates_count + '</b><br>'
                        }
                        html += text
                    })
                    return html
                }
            },   
            plotOptions: {
                series: {
                    label: {
                        connectorAllowed: false
                    },
                    events:{
                        legendItemClick: function(){
                            let id = this.userOptions.id
                            if(id == 'reference_values'){
                                //remover/adicionar plots
                                let visible = this.visible
                                if(!visible){
                                    addPlotLines()
                                } else {
                                    removePlotLines()
                                    setChartLimits([])
                                }
                            }
                            return true
                        }
                    },
                    marker:{
                        enabled:false,
                        states:{
                            hover:{
                                enabled:true
                            }
                        }
                    },
                    dataLabels: {
                        enabled: data_type.includes('level') || data_type.includes('flow') ? true : false,
                        useHTML:true,
                        formatter: function(){
                            const getStyle = value =>{
                                let status = stationHelper.referenceByValue(current_station.id, value*100);
                                if(status){
                                    let colors = stationHelper.colorByReference(status)
                                    return `border:1px solid ${colors.full};backgroundColor: ${colors.light}`
                                }
                            }
                            //exibir label apenas no valor max e min
                            let maxIndex = this.series.yData.indexOf(Math.max(...this.series.yData))
                            let minIndex = this.series.yData.indexOf(Math.min(...this.series.yData))
                            let maxTimestamp = this.series.xData[maxIndex]
                            let minTimestamp = this.series.xData[minIndex]

                            if(this.x === maxTimestamp){
                                
                                return `<div class='data-label-container data-label-max' style='${getStyle(this.y)}'>MAX: ${this.y.toFixed(3)}</div>`
                            } else if(this.x === minTimestamp){
                                return `<div class='data-label-container data-label-min' style='${getStyle(this.y)}'>MIN: ${this.y.toFixed(3)}</div>`
                            }
                        }
                    }
                }
            },
            series: series
        
        });
    }
}

Chart.prototype = Object.create(BaseConstructor.prototype)